import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPublicLobbies, getSpotifyLoginUrl } from '../api';

function Home() {
  const navigate = useNavigate();
  const [publicLobbies, setPublicLobbies] = useState([]);
  const [loadingLobbies, setLoadingLobbies] = useState(true);

  useEffect(() => {
    loadLobbies();
    const interval = setInterval(loadLobbies, 10000);
    return () => clearInterval(interval);
  }, []);

  const loadLobbies = async () => {
    try {
      const data = await getPublicLobbies();
      setPublicLobbies(data.lobbies || []);
    } catch (e) {}
    setLoadingLobbies(false);
  };

  const handleSpotifyLogin = async () => {
    try {
      const data = await getSpotifyLoginUrl();
      window.location.href = data.url;
    } catch (e) {}
  };

  return (
    <div className="home-page">
      <div className="home-container">
        <div className="logo-section">
          <h1 className="app-title">
            <span className="title-icon">🎵</span> Song Battle
          </h1>
          <p className="app-subtitle">
            Lass deine Lieblingssongs gegeneinander antreten!
          </p>
        </div>

        <div className="mode-selection">
          <button 
            className="mode-card multiplayer"
            onClick={() => navigate('/join')}
          >
            <div className="mode-icon">👥</div>
            <h2>Multiplayer</h2>
            <p>Erstelle eine Lobby und stimme mit Freunden ab</p>
          </button>

          <button 
            className="mode-card solo"
            onClick={() => navigate('/solo')}
          >
            <div className="mode-icon">🎧</div>
            <h2>Solo</h2>
            <p>Wähle ein Genre und entscheide alleine</p>
          </button>
        </div>

        <div className="home-actions">
          <button className="btn btn-spotify" onClick={handleSpotifyLogin}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/></svg>
            Mit Spotify anmelden
          </button>
          <button className="btn btn-ghost" onClick={() => navigate('/import')}>
            📥 Playlist importieren
          </button>
        </div>

        {publicLobbies.length > 0 && (
          <div className="public-lobbies-section">
            <h3 className="public-lobbies-title">🌐 Öffentliche Lobbys</h3>
            <div className="public-lobbies-list">
              {publicLobbies.map(lobby => (
                <div
                  key={lobby.roomCode}
                  className="public-lobby-card"
                  onClick={() => navigate(`/join/${lobby.roomCode}`)}
                >
                  <div className="public-lobby-info">
                    <span className="public-lobby-host">{lobby.hostName}</span>
                    <span className="public-lobby-meta">
                      👥 {lobby.playerCount} • 🎵 {lobby.songsSubmitted}/{lobby.songCount}
                    </span>
                  </div>
                  <span className="public-lobby-code">{lobby.roomCode}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;
